import { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import { MixedWidget22 } from '../../../_metronic/partials/widgets'
import { SpaceRentalDetailsHeader } from './SpaceRentalDetailsHeader'
import Swal from 'sweetalert2'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const ViewRentableSpaceList: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '4') {
      navigate('../dashboard/');
    }
  }, [categoryId])
  const location = useLocation();
  const editSpacerentalId = (location.state as any)?.spacerentalId || '';
  // -------- state start ------------ 
  const [editRentableSpaceId, setEditRentableSpaceId] = useState("");
  const [spaceDetails, setSpaceDetails] = useState([]);
  const [primLanguage, setPrimLanguage] = useState("");

  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9);
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [displayRentableSpaceList, setDisplayRentableSpaceList] = useState([]);
  const [pageNumbersList, setPageNumberList] = useState([1])
  // ----------- state end ------------

  // ----------------------- functions ---------------------------- 
  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Generate the list of page numbers
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }
  // on page change function
  const onpagecahnge = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = spaceDetails.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit

        }
        else {
          tolimi = pageId * limit + limit
        }
      }
      else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = spaceDetails.slice(tmp, tolimi)
      setDisplayRentableSpaceList(tmpdata)
    }

  }

  // ------------------------------------- apis call ------------------------------------
  // space Details api call
  const spacerentalDetailsApiCall = async () => {

    var param: any = {
      spacerentalId: String(editSpacerentalId),
    }
    var response: any = await fetchData("public/spaceDetails", param)

    if (response.status == "200") {
      var rentableSpaceList = response.data[0]['rentablespace'];
      setSpaceDetails(rentableSpaceList);
      setPrimLanguage(response.data[0]['primaryLanguage'])
      var tmp: any = rentableSpaceList.slice(offset, offset + limit);
      setDisplayRentableSpaceList(tmp)
      var totpag = (Math.ceil(rentableSpaceList.length / limit))
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = rentableSpaceList.length % limit
        if (mod > 0) {
          setTo(mod)
        }
        else {
          setTo(tmp.length)
        }
      }
      else {
        var mod = rentableSpaceList.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        }
        else {
          setTo(page * limit)
        }
      }
      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)
    }
    else {
      toasterrormsg(response.message)
    }
  }

  //   delete rentable space api call
  const confirmdelete = (rentablespaceId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {

        var param = {
          'rentablespaceId': rentablespaceId
        }
        var res = await fetchData("public/deleteRentableSpace", param)

        if (res.status == "200") {
          spacerentalDetailsApiCall();
        }
        else {
          toasterrormsg(res.message)
        }
      }
    });
  }
  const editModalOpen = (roomId: any) => {
    setEditRentableSpaceId(roomId);
  }
  useEffect(() => {
    spacerentalDetailsApiCall();
  }, [editRentableSpaceId])

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('View Rentable Space List')}</PageTitle>
      <ToastContainer />
      <SpaceRentalDetailsHeader />
      {/* begin::Row */}
      <div className='row g-5 g-xl-8 mt-3'>
        {
          displayRentableSpaceList.map((space: any, index: any) => {
            var description = getTranslatedValue(lang, space, '_spaceInformation', primLanguage);
            var spaceName = getTranslatedValue(lang, space, '_name', primLanguage);
            return (
              <div className='col-xl-4' key={index}>
                <MixedWidget22
                  className='card-xl-stretch mb-5 mb-xl-8'
                  color='success'
                  rentablespaceId={space['rentablespaceId']}
                  deleteRentableSpace={confirmdelete}
                  rentableSpaceName={spaceName}
                  image={(space['images'].length != 0) ? space['images'][0].thumbPath : toAbsoluteUrl("/media/logos/InsayrLogo.png")}
                  description={description}
                  availablespace={space['availablespace']}
                  maxPeople={space['maxPeople']}
                  progress='100%'
                />
              </div>
            )
          })
        }
      </div>
      {
        spaceDetails.length != 0 ? (
          <>
            <div className='d-flex flex-stack flex-wrap pt-10'>
              <div className='fs-6 fw-bold text-gray-700'>Showing {from} to {to} of {spaceDetails.length} entries</div>

              <ul className='pagination'>

                <li className={`page-item previous ${page > 1 ? "" : "disabled"}`}>
                  <span className={`page-link ${page > 1 ? "cursor-pointer" : "disabled"}`} onClick={() => onpagecahnge(page - 1)}>
                    <i className='previous'></i>
                  </span>
                </li>
                {pageNumbersList.map((item: any) => {

                  return (
                    <li className={`page-item cursor-pointer ${page == item ? "active" : ""}`}>
                      <span className='page-link' onClick={() => onpagecahnge(item)}>
                        {item}
                      </span>
                    </li>
                  )
                })}

                <li className={`page-item next ${page + 1 <= totalPage ? "" : "disabled"}`}>
                  <span className={`page-link ${page + 1 <= totalPage ? "cursor-pointer" : "disabled"}`} onClick={() => page + 1 <= totalPage ? onpagecahnge(page + 1) : ""}>
                    <i className='next'></i>
                  </span>
                </li>
              </ul>
            </div>
          </>
        ) : ('')
      }
      {/* end::Row */}

    </>
  )
}

export { ViewRentableSpaceList }
